import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

export const Selected = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  user-select: none;

  &:focus-visible {
    outline: 2px solid ${theme.color.border.selected};
    outline-offset: 2px;
  }
`;

export const OptionsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 100%;
  border: 1px solid ${theme.color.border.default};
  border-top: none;
  background: white;
  max-height: 15rem;
  overflow-y: auto;
  z-index: 10;
`;

export const Option = styled.li`
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${theme.color.border.selected};
    outline-offset: -2px;
  }
`;

export const MobileNativeSelect = styled.select`
  @media (min-width: ${breakpoints.md}) {
    display: none;
  }

  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
